import { render, staticRenderFns } from "./discord.vue?vue&type=template&id=cd8b5dce&"
import script from "./discord.vue?vue&type=script&lang=js&"
export * from "./discord.vue?vue&type=script&lang=js&"
import style0 from "./discord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports